import { render, staticRenderFns } from "./LiveHotProductBar.vue?vue&type=template&id=19f38a64&scoped=true"
import script from "./LiveHotProductBar.vue?vue&type=script&lang=js"
export * from "./LiveHotProductBar.vue?vue&type=script&lang=js"
import style0 from "./LiveHotProductBar.vue?vue&type=style&index=0&id=19f38a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f38a64",
  null
  
)

export default component.exports